import { useCallback, useEffect, useState } from "react";
import { RangedAttributeValidationCode, } from "../../../../types";
import { useProductOptionContext } from "../../../product-option/context";
import { useProductOptionsTranslations } from "../../../product-options-translations/product-option-translations";
import { buildRangesType, validateRangeInput } from "../utils/rangedAttribute";
import { getHelperText, getValidationMessage } from "../utils/getRangeMessages";
export const useTextboxOptions = (unitOfMeasure, isDisabled, onChanged) => {
    const { showFormErrors, productOption } = useProductOptionContext();
    const [currentInput, setCurrentInput] = useState(productOption.selectedKey ?? null);
    const [showTypeFormErrors, setShowTypeFormErrors] = useState(!!showFormErrors);
    const { i18n, i18nUnsafe } = useProductOptionsTranslations();
    const rangeInformation = buildRangesType(productOption.choices);
    const { helperText } = getHelperText(i18n, i18nUnsafe, rangeInformation, unitOfMeasure);
    const [textboxMessage, setTextBoxMessage] = useState({ message: undefined, isValid: true });
    useEffect(() => {
        const validationResult = validateRangeInput(currentInput, productOption, showTypeFormErrors);
        const newValidationMessage = getValidationMessage({
            isConstrained: isDisabled,
            validationCode: validationResult.code,
            additionalInformation: validationResult.additionalInformation,
            rangeInformation,
            unitOfMeasure,
            i18n,
            i18nUnsafe,
        });
        if (currentInput !== productOption.selectedKey && (productOption.selectedKey || currentInput)) {
            onChanged({
                choiceKey: validationResult.code === RangedAttributeValidationCode.SUCCESS ? currentInput : null,
                choiceKeyWithInvalids: currentInput ?? undefined,
                isValid: validationResult.code === RangedAttributeValidationCode.SUCCESS,
                code: validationResult.code,
                additionalInformation: validationResult.additionalInformation,
            });
        }
        if (newValidationMessage) {
            setTextBoxMessage({
                message: newValidationMessage,
                isValid: validationResult.code === RangedAttributeValidationCode.SUCCESS,
            });
        }
        else {
            setTextBoxMessage({
                message: helperText,
                isValid: validationResult.code === RangedAttributeValidationCode.SUCCESS,
            });
        }
    }, [showTypeFormErrors, currentInput]);
    const handleProductChoiceChangedEvent = useCallback((event) => {
        const { choiceKey } = event;
        setCurrentInput(choiceKey);
        setShowTypeFormErrors(true);
    }, []);
    return { handleProductChoiceChangedEvent, textboxMessage };
};
//# sourceMappingURL=use-textbox-options.js.map